import React from 'react'
import Feedback from './components/feedback'
import {
  openExemptSalaryThresholdRequirementsFile,
  openIndexingJurisdictionsFile,
  openCanadianMinWageDoc,
  openFederalContractorPaidSickLeaveFile,
  openBereavementLeaveRequirementsFile,
  openFederalEmployeePaidParentalLeaveFile,
  openJuryDutyLeaveRequirementsFile,
  openVotingLeaveRequirementsFile,
  openPayTransparencyAndSalaryHistoryBanJurisdictions,
  openFederalFamilyAndMedicalLeaveAct
} from '../static-files/static-pdf-service'

export const NAME = 'app'

export const getComplianceMenu = (hasPaidLeave) => (hasPaidLeave ? [MIN_WAGE_OPTION, PAID_LEAVE_OPTION] : [MIN_WAGE_OPTION])

export const getMinWageMenu = (hasPaidLeave) => (hasPaidLeave ? [COMPLIANCE_OPTION, PAID_LEAVE_OPTION] : [COMPLIANCE_OPTION])

export const getPaidLeaveMenu = () => [COMPLIANCE_OPTION, MIN_WAGE_OPTION]

export const POSTINGS_DATABASE_VALUE = 'POSTINGS'
export const MINWAGE_DATABASE_VALUE = 'MINIMUM_WAGE'
export const PAIDLEAVE_DATABASE_VALUE = 'PAID_LEAVE'

const MIN_WAGE_OPTION = {
  text: 'Minimum Wage',
  path: '/minWage'
}

const COMPLIANCE_OPTION = {
  text: 'Postings',
  path: '/compliance'
}

const PAID_LEAVE_OPTION = {
  text: 'Paid Leave',
  path: '/paidLeave'
}

export const SWITCH_COMPANY_OPTION = [
  {
    text: 'Switch Companies',
    path: '/compliance/companies/switch'
  }
]

export const COMPLIANCE_USER_MENU = [
  {
    text: 'Help',
    path: '/compliance/help'
  },
  {
    text: 'Feedback',
    modal: {
      component: <Feedback />,
      title: 'GovDocs Product Feedback Form'
    }
  },
  {
    text: 'Logout',
    action: 'logout'
  }
]

export const MINWAGE_USER_MENU = [
  {
    text: 'Company Settings',
    path: '/minWage/settings'
  },
  {
    text: 'User Preferences',
    path: '/minWage/user-preferences'
  },
  {
    text: 'Help',
    path: '/minWage/help'
  },
  {
    text: 'Feedback',
    modal: {
      component: <Feedback />,
      title: 'GovDocs Product Feedback Form'
    }
  },
  {
    text: 'Logout',
    action: 'logout'
  }
]

export const PAIDLEAVE_USER_MENU = [
  {
    text: 'Feedback',
    modal: {
      component: <Feedback />,
      title: 'GovDocs Product Feedback Form'
    }
  },
  {
    text: 'User Preferences',
    path: '/paidLeave/user-preferences'
  },
  {
    text: 'Logout',
    action: 'logout'
  }
]

export const RESOURCES_MENU = [
  {
    text: 'Exempt Salary Data',
    request: openExemptSalaryThresholdRequirementsFile
  },
  {
    text: 'Pay Transparency and Salary History Ban Jurisdictions',
    request: openPayTransparencyAndSalaryHistoryBanJurisdictions
  },
  {
    text: 'Indexing Jurisdictions',
    request: openIndexingJurisdictionsFile
  },
  {
    text: 'Canada Minimum Wage Rates',
    request: openCanadianMinWageDoc
  }
]

export const PAID_LEAVE_RESOURCES_MENU = [
  {
    text: 'Bereavement Leave Requirements',
    request: openBereavementLeaveRequirementsFile
  },
  {
    text: 'Federal Contractor PSL',
    request: openFederalContractorPaidSickLeaveFile
  },
  {
    text: 'Federal Employee Parental Leave Requirements',
    request: openFederalEmployeePaidParentalLeaveFile
  },
  {
    text: 'Federal Family and Medical Leave Act',
    request: openFederalFamilyAndMedicalLeaveAct
  },
  {
    text: 'Jury Duty Leave Requirements',
    request: openJuryDutyLeaveRequirementsFile
  },
  {
    text: 'Voting Leave Requirements',
    request: openVotingLeaveRequirementsFile
  }
]

export const NS_NULL_VALUE = '- None -'
